import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Wrench } from "lucide-react";

export default function MaintenanceBanner() {
  const [m, setM] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/maintenance").then((r) => setM(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    window.addEventListener("maintenance-changed", load);
    return () => { clearInterval(t); window.removeEventListener("maintenance-changed", load); };
  }, []);
  if (!m?.enabled) return null;
  return (
    <div data-testid="maintenance-banner" className="flex items-center gap-2 bg-amber-500 px-4 py-2 text-sm font-semibold text-white">
      <Wrench className="h-4 w-4 shrink-0" />
      <span>Bakım Modu Aktif</span>
      {m.message && <span className="font-normal opacity-90">— {m.message}</span>}
    </div>
  );
}
